/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Companydetailslegalnameplaceholder4Inputs */

const en_companydetailslegalnameplaceholder4 = /** @type {(inputs: Companydetailslegalnameplaceholder4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g. Example Ltd`)
};

const de_companydetailslegalnameplaceholder4 = /** @type {(inputs: Companydetailslegalnameplaceholder4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`z. B. Muster GmbH`)
};

/**
* | output |
* | --- |
* | "e.g. Example Ltd" |
*
* @param {Companydetailslegalnameplaceholder4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const companydetailslegalnameplaceholder4 = /** @type {((inputs?: Companydetailslegalnameplaceholder4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Companydetailslegalnameplaceholder4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_companydetailslegalnameplaceholder4(inputs)
	return de_companydetailslegalnameplaceholder4(inputs)
});
export { companydetailslegalnameplaceholder4 as "companyDetailsLegalNamePlaceholder" }